import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../hooks/useTheme.js';

var Label = forwardRef(function (props, ref) {
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(props, {
        themeKey: "label",
        baseStyle: { boxSizing: "border-box" },
    });
    return jsx("label", __assign({ ref: ref }, forwardProps));
});

export { Label };
//# sourceMappingURL=index.js.map
